<script setup lang="ts">
defineProps<{
  media?: boolean
}>()
</script>
<template>
  <time :class="{ 'time-default': !media, 'time-media': media }">
    <slot />
  </time>
</template>
<style lang="css" scoped>
.time-default {
  @apply tw-opacity-40 tw-text-[.6875rem] tw-font-bold;
}

.time-media {
  @apply tw-opacity-90 tw-text-[.6875rem] tw-text-white tw-font-bold;
}
</style>
